// import './footer.scss'
// import './header.scss'
  
function init() {
    
  }
  
  export default init